<template>
	<v-app>
		<NavBar />
		<v-main class="ma-4">
			<h1>Airplane</h1>
			<v-form v-if="this.plane">
				<v-img class="mb-4" width="400" cover :src="imagesrc"></v-img>
				<v-text-field
					v-model="this.plane.callsign"
					label="Callsign"
					:readonly="!this.editable"
					required
					:variant="this.editable ? 'solo' : 'plain'"
				></v-text-field>
				<v-text-field
					v-model="this.plane.type.Manufacturer"
					label="Manufacturer"
					readonly
					required
					variant="plain"
				></v-text-field>
				<v-text-field
					v-model="this.plane.type.Model"
					label="Model"
					:readonly="!this.editable"
					required
					:variant="this.editable ? 'solo' : 'plain'"
				></v-text-field>
				<FilePond
					v-if="this.editable"
					accepted-file-types="image/jpeg, image/png"
					name="PlanePicture"
					ref="pond"
					label-idle="Picture"
					v-on:addfile="fileprocessed"
				/>

				<v-btn v-if="!this.editable" @click="edit()">Edit</v-btn>
				<v-btn color="green" v-if="this.editable" @click="submit()">Save</v-btn>
				<v-btn color="red" v-if="this.editable" @click="reset()">Cancel</v-btn>
			</v-form>
		</v-main>
	</v-app>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import NavBar from "@/components/NavBar";
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

const FilePond = vueFilePond(
	FilePondPluginFileValidateSize,
	FilePondPluginImagePreview,
	FilePondPluginFileValidateType
);

export default {
	computed: {
		...mapState({
			token: "token",
		}),
	},
	props: ["id"],
	data: (instance) => ({
		plane: null,
		pictureUpdate: false,
		editable: false,
		instance: instance,
		imagesrc:
			process.env.VUE_APP_BACKEND_URL +
			"/plane/picture/" +
			instance.id +
			"?cacheKey=" +
			new Date().getTime(),
	}),

	components: {
		NavBar,
		FilePond,
	},
	methods: {
		fileprocessed() {
			this.pictureUpdate = true;
		},
		edit() {
			this.editable = true;
		},
		reset() {
			this.editable = false;
		},
		submit() {
			var data = new FormData();
			data.append("registration", this.plane.callsign);
			data.append("type", this.plane.type._id);
			console.log(data);
			if (this.pictureUpdate) {
				try {
					data.append(
						"planepicture",
						this.$refs.pond.getFile(0).file,
						this.$refs.pond.getFile(0).filename
					);
				} catch {
					console.log("No file uploaded");
				}
			}
			console.log(data);
			try {
				axios.put(process.env.VUE_APP_BACKEND_URL + "/plane/" + this.id, data, {
					headers: {
						Authorization: "bearer " + this.token,
						"Content-Type": "multipart/form-data",
					},
				});
				this.editable = false;
			} catch (e) {
				this.error = e.message;
				console.log(e.message);
			}
			this.imagesrc =
				process.env.VUE_APP_BACKEND_URL +
				"/plane/picture/" +
				this.instance.id +
				"?cacheKey=" +
				new Date().getTime();
		},
	},
	mounted() {
		axios
			.get(process.env.VUE_APP_BACKEND_URL + "/plane/" + this.id, {
				headers: {
					Authorization: "bearer " + this.token,
				},
			})
			.then((response) => {
				this.plane = response.data;
				console.log(this.plane);
			})
			.catch((e) => {
				console.error(e);
			});
	},
};
</script>

<style></style>
